export class SheetActivity {
  id: number
  student_id: number
  score: number
  saiten_completed: boolean
  page: number

  constructor(sheetActivity: any){
    this.id = sheetActivity.id;
    this.student_id = sheetActivity.student_id;
    this.score = sheetActivity.score;
    this.saiten_completed = sheetActivity.saiten_completed;
    this.page = sheetActivity.page
  }
}

export class Student {
  id: number
  user_id: number
  student_num: number
  student_name: string
  nendo: number
  grade_id: number
  room_id: number
  number: number

  constructor(student: any){
    this.id = student.id;
    this.user_id = student.user_id;
    this.student_num = student.student_num;
    this.student_name = student.name;
    this.nendo = student.nendo;
    this.grade_id = student.grade_id;
    this.room_id = student.room_id;
    this.number = student.number;
  }
}

export class FieldActivity {
  id: number
  sheet_activity_id: number
  sheet_field_id: number
  score: number | null
  score_cache: number | null
  correct_state: number | null
  correct_state_cache: number | null
  recog_text: string
  confidence: number
  recog_errors: string[]
  saiten_completed: boolean
  is_correct_changed: boolean
  is_correct_changed_cache: boolean
  sheetActivity: SheetActivity
  student: Student
  base64Image: string | null = null
  base64Canvas: string | null = null
  isCanvasEdited: boolean = false
  base64PreviewImages: string[] = []
  svgContent: string
  
  constructor(fieldActiviby: any, sheetActivities: any[], students: any[], base64ImageHashArray: any[], base64CanvasHashArray: any[], page_count: number){
    this.id = fieldActiviby.id;
    this.sheet_activity_id = fieldActiviby.sheet_activity_id;
    this.sheet_field_id = fieldActiviby.sheet_field_id;
    // 未採点は○×順ソート用に-1を設定
    this.score = fieldActiviby.score == null ? -1 : fieldActiviby.score;
    this.score_cache = fieldActiviby.score == null ? -1 : fieldActiviby.score;
    this.correct_state = fieldActiviby.correct_state;
    this.correct_state_cache = fieldActiviby.correct_state;
    this.recog_text = fieldActiviby.recog_text;
    this.saiten_completed = fieldActiviby.saiten_completed;
    this.is_correct_changed = fieldActiviby.is_correct_changed;
    this.is_correct_changed_cache = fieldActiviby.is_correct_changed;
    this.sheetActivity = new SheetActivity(sheetActivities.filter((x: any) => x.id == this.sheet_activity_id)[0]);
    this.student = new Student(students.filter((x: any) => x.user_id == this.sheetActivity.student_id)[0]);
    const base64Image = base64ImageHashArray.filter(x => x.field_activity_id == this.id);
    if(base64Image.length > 0){
      this.base64Image = base64Image[0].src;
    }
    const base64Canvas = base64CanvasHashArray.filter(x => x.field_activity_id == this.id);
    if(base64Canvas.length > 0){
      this.base64Canvas = base64Canvas[0].src;
    }
  }
}

export class ParamFieldActivity {
  id: number
  sheet_activity_id: number
  score: number | null
  correct_state: number | null
  is_correct_changed: boolean

  constructor(fieldActivity: FieldActivity){
    this.id = fieldActivity.id;
    this.sheet_activity_id = fieldActivity.sheet_activity_id;
    this.score = fieldActivity.score == -1 ? null : fieldActivity.score;
    this.correct_state = fieldActivity.correct_state;
    this.is_correct_changed = fieldActivity.is_correct_changed;
  }
}

export class Sheet {
  id: number
  sheet_group_key: number
  nendo: number
  grade: number
  page_count: number
  kind: number
  allot: number
  name: string
  subject_id: number
  subject_name: string
  field_names_completed: boolean
  corretct_image_completed: boolean
  exec_date: string

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.grade = sheet.grade;
    this.page_count = sheet.page_count;
    this.kind = sheet.kind;
    this.allot = sheet.allot;
    this.name = sheet.name;
    this.subject_id = sheet.subject_id;
    this.subject_name = sheet.subject_name;
    this.field_names_completed = sheet.field_names_completed;
    this.corretct_image_completed = sheet.corretct_image_completed;
    this.exec_date = sheet.exec_date;
  }
}

export class SheetField {
  id: number
  part1: string
  part2: string
  part3: string
  allot: number
  allotCache: number
  page: number
  scoreAverage: number
  scoreRate: number
  isSaitenCompleted: boolean
  partial_scorable: boolean
  baseWidth: number
  baseHeight: number
  addition: string
  scoring_type: number
  recog_type: number
  recog_correct_text: string

  constructor(sheetField: any, buffSize: number){
    this.id = sheetField.id;
    this.part1 = sheetField.part1;
    this.part2 = sheetField.part2;
    this.part3 = sheetField.part3;
    this.allot = sheetField.allot;
    this.page = sheetField.page;
    this.partial_scorable = sheetField.partial_scorable;
    this.baseWidth = sheetField.rim[2] + (buffSize * 2);
    this.baseHeight = sheetField.rim[3] + (buffSize * 2);
    this.addition = sheetField.addition;
    this.scoring_type = sheetField.scoring_type;
    this.recog_type = sheetField.recog_type;
    this.recog_correct_text = sheetField.recog_correct_text;
  }
}

export class Point {
  x: number
  y: number
  
  constructor(x: number, y: number){
    this.x = x;
    this.y = y;
  }
}

export const SaitenModeEnum = Object.freeze({
  None: 0,
  KeyInput: 1, 
  SeitouClick: 2, 
  GotouClick: 3, 
  TokutenClick: 4, 
  FreeLine: 5,
  StraightLine: 6,
  BracesStart: 7,
  BracesEnd: 8,
  Number: 9,
  Eraser: 10,
  TextStamp: 11
});
export const CorrectStateEnum = Object.freeze({Seitou: 1, Gotou: -1, Tokuten: 0});
export const SortKindEnum = Object.freeze({No: 1, CorrectState: 2, FileSize: 3});
